import React from 'react';
import { Check } from 'lucide-react';
import { Link } from 'react-router-dom';
import { ServicePageLayout } from '../components/ServicePageLayout';
export function FullCarDetailPage() {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: 'Full Car Detail',
    provider: {
      '@type': 'LocalBusiness',
      name: "Mike's Pro Detail",
      telephone: '+18183819905'
    },
    areaServed: ['Camarillo', 'Thousand Oaks', 'Ventura County', 'Los Angeles'],
    description: 'Complete mobile full car detailing service combining deep interior cleaning and premium exterior wash, clay bar, and wax protection.'
  };
  const faqs = [{
    question: 'What is included in a full car detail?',
    answer: 'A full detail combines our complete interior and exterior services: deep vacuuming, shampooing, steam sanitizing, leather conditioning, a safe hand wash, clay bar decontamination, wheel and tire detailing, and premium paint protection.'
  }, {
    question: 'How long does a full detail take?',
    answer: 'A full detail typically takes 3\u20134 hours depending on the size and condition of your vehicle. We never rush \u2014 quality results take proper time and attention.'
  }, {
    question: 'How much does a full car detail cost?',
    answer: 'Our full detail starts at $300, with pricing adjusted for vehicle size and condition. SUVs and trucks are slightly higher. Call (818) 381-9905 for an exact quote.'
  }, {
    question: 'Is a full detail worth it before selling my car?',
    answer: 'Absolutely. A full detail is one of the most cost-effective ways to maximize resale value, presenting your vehicle in its best possible condition inside and out.'
  }, {
    question: 'Do you come to my home or office for a full detail?',
    answer: 'Yes. We are fully mobile, bringing our own water and detailing equipment to your home or office anywhere in Ventura County. We require access to a standard electrical outlet at the service location.'
  }];
  const breadcrumbs = [{
    name: 'Home',
    item: 'https://www.fulldetailpro.com/'
  }, {
    name: 'Services',
    item: 'https://www.fulldetailpro.com/#services'
  }, {
    name: 'Full Car Detail',
    item: 'https://www.fulldetailpro.com/services/full-car-detail'
  }];
  return <ServicePageLayout title="Full Car Detail Ventura County" subtitle="Our most popular package. A complete bumper-to-bumper transformation combining our premium interior and exterior detailing services." metaDescription="Complete full car detail in Ventura County \u2014 Camarillo, Oxnard & Thousand Oaks. Mobile interior deep clean + exterior wax & wax. Call (818) 381-9905." schema={schema} faqs={faqs} breadcrumbs={breadcrumbs} data-id="element-902" data-mp="2imgq6dp5jh0o">
      <p data-id="element-903" data-mp="1zow41edruwjr">
        If you want your vehicle to look and feel as close to brand new as
        possible, our <strong data-id="element-904" data-mp="3q1bno79bet6h">Full Car Detail</strong> is the ultimate solution.
        This comprehensive package combines the deep-cleaning power of our
        interior detailing with the protective, gloss-enhancing benefits of our
        exterior detailing. At Mike's Pro Detail, we provide top-tier mobile
        auto detailing in Camarillo CA, Thousand Oaks, and throughout Ventura
        County, bringing a complete automotive makeover directly to your
        driveway or workplace.
      </p>

      <h2 data-id="element-905" data-mp="1nck7bur30kmy">What's Included in a Full Detail?</h2>
      <p data-id="element-906" data-mp="1nbimiyk9kjs1">
        The Full Detail package leaves no stone unturned. We spend hours
        meticulously cleaning, restoring, and protecting every surface of your
        vehicle.
      </p>

      <h3 data-id="element-907" data-mp="1x5ivxcmkwb6k">Exterior Services:</h3>
      <ul className="space-y-4 my-6 list-none pl-0" data-id="element-908" data-mp="2b2xo2p47ux28">
        <li className="flex items-start" data-id="element-909" data-mp="2b2o0t9ak3408">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-910" data-mp="264comrwsgheu" />
          <span data-id="element-911" data-mp="26207ui2rod3d">Wash method to safely remove surface dirt and grime.</span>
        </li>
        <li className="flex items-start" data-id="element-912" data-mp="gpeyc1gfgirh">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-913" data-mp="bqbqyacz60gc" />
          <span data-id="element-914" data-mp="bs6abk8llkib">
            <strong data-id="element-915" data-mp="e4qlnxnyslm4">Decontamination & Clay Bar:</strong> Removal of embedded
            iron particles, tree sap, and road tar to leave the paint smooth.
          </span>
        </li>
        <li className="flex items-start" data-id="element-916" data-mp="i86juyfomu0x">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-917" data-mp="n55d7eriuwy2" />
          <span data-id="element-918" data-mp="s4huzl3jddts">
            <strong data-id="element-919" data-mp="s51g1aohgic1">Wheel & Tire Detail:</strong> Deep cleaning of wheel
            barrels, faces, and tires, finished with a premium no-sling
            dressing.
          </span>
        </li>
        <li className="flex items-start" data-id="element-920" data-mp="3vkp0zy9fbn5q">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-921" data-mp="3vlrp5yfd3bhy" />
          <span data-id="element-922" data-mp="4enjb6uydvb4">
            <strong data-id="element-923" data-mp="4e5j5z566wxx">Paint Protection:</strong> Application of a high-grade
            hybrid ceramic wax or sealant for months of gloss and UV protection.
          </span>
        </li>
      </ul>

      <h3 data-id="element-924" data-mp="37uupbk0uc4n2">Interior Services:</h3>
      <ul className="space-y-4 my-6 list-none pl-0" data-id="element-925" data-mp="37tjl5j3hguvf">
        <li className="flex items-start" data-id="element-926" data-mp="3ctp66gf8zj4j">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-927" data-mp="3csnss5arekjn" />
          <span className="font-[400]" data-id="element-928" data-mp="359ws4863qsje">
            Deep Vacuuming: Thorough removal of dirt and pet hair, followed
            steam clean carpets and cloth seats.
          </span>
        </li>
        <li className="flex items-start" data-id="element-929" data-mp="2vbqpfoch1idh">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-930" data-mp="2vev2zcbttqgt" />
          <span data-id="element-931" data-mp="2qdfd96ypevs3">
            <strong data-id="element-932" data-mp="2qg1l77pibdau">Leather Treatment:</strong> Gentle cleaning and premium
            conditioning to restore softness and prevent cracking.
          </span>
        </li>
        <li className="flex items-start" data-id="element-933" data-mp="2hkve85ei2p6q">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-934" data-mp="2cmk21o0qg2lc" />
          <span data-id="element-935" data-mp="2cmtv5kh2qpv9">
            <strong data-id="element-936" data-mp="2ck7mfhig64bg">Surface Sanitization:</strong> Steam cleaning of vents, cup
            holders, and dashboard to kill bacteria and remove sticky residues.
          </span>
        </li>
        <li className="flex items-start" data-id="element-937" data-mp="22qh1unpfye11">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-938" data-mp="1ym9byn78ys18" />
          <span data-id="element-939" data-mp="1yp5b2eutzmr9">
            <strong data-id="element-940" data-mp="1o1xfv349s0og">Crystal Clear Glass:</strong> Streak-free cleaning of all
            interior and exterior windows and mirrors.
          </span>
        </li>
      </ul>

      <h2 data-id="element-941" data-mp="1synx3trt92bg">The Ultimate Value and Convenience</h2>
      <p data-id="element-942" data-mp="1f1ra63etc4zu">
        Booking a Full Car Detail is the most cost-effective way to completely
        reset your vehicle's condition. Whether you are preparing to sell your
        car, returning a lease, or simply want to fall in love with your daily
        driver all over again, this package delivers unmatched results. Plus,
        because we are a fully mobile operation, you don't have to waste your
        day sitting in a waiting room. We bring our own water and detailing
        equipment, and we require access to a standard electrical outlet at the
        service location, allowing you to continue working or relaxing at home
        while we transform your car.
      </p>

      <h2 data-id="element-943" data-mp="2vfr6z5id3eiv">Your Local Mobile Detailing Experts</h2>
      <p data-id="element-944" data-mp="2vgk5jj762xpx">
        When residents search for "Car Detailing Camarillo" or "Mobile Detailing
        Ventura County", they consistently choose Mike's Pro Detail for our
        reliability, attention to detail, and exceptional customer service. From
        Calabasas to Moorpark, we are dedicated to providing the highest
        standard of mobile auto detailing available in Southern California.
      </p>

      <h2 data-id="element-945" data-mp="39muf20wfcike">Related Detailing Services</h2>
      <div className="not-prose grid grid-cols-1 sm:grid-cols-2 gap-3 my-6" data-id="element-946" data-mp="2lune0ofr7nen">
        <Link to="/services/interior-detailing" className="block px-4 py-3 bg-zinc-900/60 border border-zinc-800 rounded-lg text-white font-bold hover:border-red-900/60 hover:bg-zinc-800/60 transition-all" data-id="element-947" data-mp="2htldm4a3p5b3">
          Interior Detailing &rarr;
        </Link>
        <Link to="/services/exterior-detailing" className="block px-4 py-3 bg-zinc-900/60 border border-zinc-800 rounded-lg text-white font-bold hover:border-red-900/60 hover:bg-zinc-800/60 transition-all" data-id="element-948" data-mp="2qsox39d6jmq4">
          Exterior Detailing &rarr;
        </Link>
        <Link to="/services/engine-bay-detailing" className="block px-4 py-3 bg-zinc-900/60 border border-zinc-800 rounded-lg text-white font-bold hover:border-red-900/60 hover:bg-zinc-800/60 transition-all" data-id="element-949" data-mp="20ksubuvv0n3b">
          Engine Bay Detailing &rarr;
        </Link>
        <Link to="/services/ceramic-coating" className="block px-4 py-3 bg-zinc-900/60 border border-zinc-800 rounded-lg text-white font-bold hover:border-red-900/60 hover:bg-zinc-800/60 transition-all" data-id="element-950" data-mp="29iur1y8k8tks">
          Ceramic Coating &rarr;
        </Link>
      </div>
    </ServicePageLayout>;
}